<template>
  <div v-loading="loading">
    <el-form
        ref="signInForm"
        :model="form"
        :rules="rules"
        status-icon
        label-width="120px"
        label-position="top"
        hide-required-asterisk
        class="sign-in-form"
    >
      <el-form-item label="Login" prop="username" v-if="isTestDomain">
        <el-input
            size="large"
            v-model="form.username"
            autocomplete="off"
            placeholder="Login"
        >
          <template #prefix>
            <img
                height="18"
                src="@/assets/images/icons/fi-rr-user.svg"
                alt=""
            />
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label="Parol" prop="password" v-if="isTestDomain">
        <el-input
            size="large"
            v-model="form.password"
            type="password"
            autocomplete="off"
            placeholder="Parol"
            show-password
            @keyup.enter="submitForm"
        >
          <template #prefix>
            <img
                height="18"
                src="@/assets/images/icons/fi-rr-lock.svg"
                alt=""
            />
          </template>
        </el-input>
      </el-form-item>
      <el-form-item
          :element-loading-spinner="svg"
          element-loading-svg-view-box="-10, -10, 50, 50"
          element-loading-background="rgba(122, 122, 122, 0.3)"
          style="padding-bottom: 5px;"
          label="Rasimdagi matematik amalni hisoblang"
          v-if="isTestDomain && captcha?.image">
        <div style="display: flex;align-items: center;gap:5px">
          <el-button size="large" @click="getCaptchaImage">
            <img src="@/assets/images/refresh.svg" alt=""/>
          </el-button>
          <img alt="" style="min-width: 120px" class="captcha-img"
               :src="`data:image/png;base64,${captcha.image}`"/>
          <el-input
              name="captcha-result"
              id="captchaResult"
              size="large"
              :aria-required="true"
              class="captcha-result"
              @input="onChangeCaptcha"
              v-model="captcha.result"
              v-maska
              data-maska="######"
          />
        </div>
      </el-form-item>
      <el-form-item v-if="isTestDomain">
        <el-button
            v-if="isTestDomain"
            size="large"
            type="primary"
            @click="submitForm"
            class="form-button blue"
        >TIZIMGA KIRISH
        </el-button>
        <!--        <el-button-->
        <!--            v-else-->
        <!--            size="large"-->
        <!--            type="primary"-->
        <!--            @click="checkCaptchaResult"-->
        <!--            class="form-button blue"-->
        <!--        >TIZIMGA KIRISH-->
        <!--        </el-button>-->
      </el-form-item>
      <el-form-item>
        <el-button
            size="large"
            type="primary"
            @click="getVerifier"
            class="form-button blue"
        >SSO orqali kirish
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import {generate} from "@/components/generators/VerifierGenerator";
import {vMaska} from 'maska'
import t, {b} from "../../../o";

export default {
  name: "LoginForm",
  components: [vMaska],
  mounted() {
    if (window) {
      this.isTestDomain = window.location.href.startsWith("http://localhost") || window.location.href.startsWith("https://console-ob.yatm.uz");
      this.getCaptchaImage();
      this.clickCounter = 0
    }
    if (this.$route.query.code) {
      this.retrieveAccessTokenWithSso(this.$route.query.code);
    }
  },
  data() {
    return {
      isTestDomain: false,
      loading: false,
      form: {
        username: null,
        password: null,
        captcha_key: null,
        captcha_result: null
      },
      rules: {
        username: [
          {required: true, trigger: "blur", message: "Majburiy maydon"},
        ],
        password: [
          {
            required: true,
            trigger: "blur",
            message: "Majburiy maydon",
          },
        ],
      },

      //   captcha
      captcha: {image: null, key: null, result: null},
      svg: `
        <path class="path" d="
          M 30 15
          L 28 17
          M 25.61 25.61
          A 15 15, 0, 0, 1, 15 30
          A 15 15, 0, 1, 1, 27.99 7.5
          L 15 15
        " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
      `,
      clickCounter: 0,
    };
  },

  methods: {
    onChangeCaptcha() {
      console.log(this.captcha)
    },
    getCaptchaImage() {
      this.captcha.image = null
      this.$http.get(`api/v2/vote/captcha-2`, {
        headers: {
          'Access-Captcha': b()
        }
      })
          .then(({data}) => {
            this.captcha.key = data.captchaKey
            this.captcha.image = data.image
            this.captcha.result = null
          })
          .catch((err) => {
            this.$message({
              message: err.response?.data?.message || "Captcha bilan muammo",
              type: "error",
            });
          })
    },
    getVerifier() {
      const a = generate();
      localStorage.setItem('challenge', a.challenge);
      localStorage.setItem('verify', a.verify);
      window.location.href = `https://sso.mf.uz/oauth2/login?clientId=console-ob&codeChallenge=${a.challenge}&redirectUri=${process.env.VUE_APP_BASE_API_REDIRECT_URL}`
    },
    retrieveAccessTokenWithSso(code) {
      axios
          .post(`${process.env.VUE_APP_BASE_API_URL}api/v1/login-by-sso`, {
            redirect_uri: process.env.VUE_APP_BASE_API_REDIRECT_URL,
            code: code,
            code_verifier: localStorage.getItem('verify')
          })
          .then(({data}) => {
            this.$store.commit("authenticate", data);
            this.loadUser();
          })
          .catch(() => {
            this.loading = false;
            this.$message({
              message: "Parol yoki foydalanuvchi nomi noto'g'ri",
              type: "warning",
            });
          })
          .finally(() => {
          });
    },

    changeLoginMode() {
      this.$emit("changeLoginMode");
    },

    loadUser() {
      this.$http
          .get("api/v1/users/profile")
          .then(({data}) => {
            this.$store.commit("userData", data);
            this.$store.commit("setRole", data?.role);
            this.$router.push("/");
          })
          .catch(() => {
            this.$store.commit("signOut");
            this.$message({
              message: "Xatolik sodir bo'ldi, iltimos qayta urinib ko'ring",
              type: "warning",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    checkCaptchaResult() {
      this.$http
          .post("api/v2/internal/verify-captcha", {
            captchaKey: this.captcha.key,
            captchaResult: parseInt(this.captcha.result)
          })
          .then(() => {
            this.$message({
              message: "Captcha tog'ri",
              type: "success",
            });
            this.submitForm()
          })
          .catch(() => {
            this.$store.commit("signOut");
            this.$message({
              message: "Xatolik sodir bo'ldi, iltimos qayta urinib ko'ring",
              type: "warning",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    submitForm() {
      this.$refs.signInForm.validate((valid) => {
        if (valid) {
          this.clickCounter++;
          if (this.clickCounter >= 6 && this.isTestDomain) {
            this.$message({
              message: "Urinishlar soni meyoridan oshib ketti",
              type: "warning",
            });
            return;
          }
          if (this.captcha.result !== this.captcha.result && this.isTestDomain) {
            this.$message({
              message: "Rasimdagi matematik amal notog'ri bajarilgan",
              type: "warning",
            });
            return
          }
          this.loading = true;
          this.form.captcha_key = this.captcha.key;
          this.form.captcha_result = parseInt(this.captcha.result);
          axios
              .post(
                  `${process.env.VUE_APP_BASE_API_URL}api/v1/admin-login`,
                  this.form
              )
              .then(({data}) => {
                this.$store.commit("authenticate", data);
                this.loadUser();
              })
              .catch(() => {
                this.loading = false;
                this.$message({
                  message: "Parol yoki foydalanuvchi nomi noto'g'ri",
                  type: "warning",
                });
              })
              .finally(() => {
                this.captcha.result = null;
                this.getCaptchaImage()
              });
        }
      });
    },
  },
};
</script>

<style scoped>
.sign-in-form {
  margin: auto;
  max-width: 458px;
}

.el-form /deep/ .el-form-item__label {
  margin-bottom: 0 !important;
  font-weight: bold;
  color: black;
  font-size: 16px;
}

.el-form /deep/ .el-input__inner {
  height: 50px;
}

.el-form /deep/ .el-form-item__label {
  font-size: 16px;
  font-family: "Montserrat-Bold", sans-serif;
}

.el-form /deep/ .form-button {
  background: #007791;
  width: 100%;
  height: 50px;
}

.el-form /deep/ .form-button.blue {
  margin-top: 10px;
}

.el-form /deep/ .form-button:hover {
  opacity: 0.8;
}

@media screen and (max-width: 800px) {
  .el-form /deep/ .el-form-item__label {
    font-size: 14px;
  }

  .el-form /deep/ .form-button,
  .el-form /deep/ .el-input__inner {
    height: 40px;
  }
}

.captcha-img {
  height: auto;
  margin-right: 3px;
}

.captcha-result {
  height: 40px;
}

</style>
